// Capabilities that are available in native app
enum NativeCapability {
  GeolocationWebView = 'GeolocationWebView',
  SebsExpansion = 'SebsExpansion'
}

export default NativeCapability;
